import { render, staticRenderFns } from "./LoginWithPhone.vue?vue&type=template&id=54ad9baf&scoped=true"
import script from "./LoginWithPhone.vue?vue&type=script&lang=js"
export * from "./LoginWithPhone.vue?vue&type=script&lang=js"
import style0 from "./LoginWithPhone.vue?vue&type=style&index=0&id=54ad9baf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad9baf",
  null
  
)

export default component.exports